module.exports = __webpack_public_path__ + "6b8d2820d9948336d1662ef5c662ae5e.svg";